module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/assessment_achievements/3@2x_fd2cd891655819488b55bb83fd0a6ff7.png";